import { statusesTranslate, statusIds } from '../constants/orders_statuses'

export const getStatusById = (statusId: string) => {
  return statusesTranslate[statusIds.indexOf(statusId)]
}
